<template>
    <div>
        <div class="app-main__inner">
            <TituloComponente icono-titulo="fas fa-clipboard-list" texto-titulo="Plan Medico"  :to-create-action="{name:'NuevoPlanMedico'}" to-create-text="Nuevo Plan Medico"/>
            <div class="tab-content">
                <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="main-card mb-3 card">
                                <div class="card-body">
                                    <h5 class="card-title">Listado de Planes Medicos</h5>
                                     <DataList ref="datatable" url="/planmedico" :fields="fields" :rowClick="mostrarOpciones"></DataList>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                               
        </div>
    </div>
</template>
<script>
import TituloComponente from '@/components/layouts/TituloComponente';
import axios from 'axios';
import DataList from '@/components/layouts/DataList';
import Swal from "sweetalert2";
export default {
    name: "ListarPLanMedico",
    components: {
        TituloComponente,
        DataList,
    },
    data(){
        return{
            planMedico: [],
            fields: [
                {
                name: "codigo",
                label: "",
                type: "title",
                class: "",
                append: '-'
                },
                {
                name: "descripcion",
                label: "",
                type: "title",
                class: ""
                }
            ],
        }
    },
    created(){
    },
    mounted(){

    },
    methods:{
        mostrarOpciones(planMedico) {
            Swal.fire({
                title: planMedico.descripcion,
                showCancelButton: true,
                confirmButtonText: "Editar",
                cancelButtonText: "Eliminar",
                confirmButtonColor: "#f7b924",
                cancelButtonColor: "#d33",
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                this.$router.push({name:'EditarPlanMedico', params:{id:planMedico.id}})
                } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
                ) {
                this.eliminarPlanMedico(planMedico)
                }
            });
        },        
        eliminarPlanMedico(planMedico) {
        Swal.fire({
            title: "¿Estás seguro?",
            text: `¿Deseas eliminar ${planMedico.descripcion} de manera permanente?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
            this.loading = true;
            axios
                .delete("planmedico/" + planMedico.id)
                .then(res => {
                Swal.fire(
                    "Eliminado",
                    `${res.data.planmedico.descripcion} se ha eliminado con éxito.`,
                    "success"
                );
                console.log(this.$refs);
                this.$refs.datatable.update();
                })
                .catch(err => console.log(err))
                .finally(() => (this.loading = false));
            }
        });
        }
    },
}
</script>
